import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';
/** Crow's-foot connector artwork identifies the tool, never its configured cardinality. */
const RelationshipIcon = forwardRef<SVGSVGElement, LucideProps>(function RelationshipIcon({ size = 24, color = 'currentColor', strokeWidth = 2, ...props }, ref) {
  return <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}><path d="M3 6L9 12L3 18M3 12H21M21 6L15 12L21 18"/></svg>;
});
export default RelationshipIcon;
